<div class="exclusive-discounts" #sectionElement>
  <!-- Indicador de dispositivo (solo para desarrollo) -->
  <div class="exclusive-discounts__device-indicator" style="position: fixed; top: 10px; right: 10px; background: rgba(0,0,0,0.8); color: white; padding: 5px 10px; border-radius: 5px; font-size: 12px; z-index: 1000;">
    Dispositivo: {{ deviceType }} ({{ getCurrentWidth() }}px)
  </div>

  <div class="exclusive-discounts__container">
    <div class="exclusive-discounts__header">
      <h2 class="exclusive-discounts__title">Revisa los descuentos exclusivos al pagar con Unipay</h2>
      <p class="exclusive-discounts__description">Descuentos y promociones en supermercados Unimarc, Mayorista 10, Super 10 y Alvi a lo largo de Chile. Online en Unimarc.cl y la APP Unimarc. Y puedes pagar todas tus cuentas en Unired.cl.</p>
    </div>

    <!-- Unimarc Section -->
    <div class="exclusive-discounts__section">
      <div class="exclusive-discounts__section-title exclusive-discounts__section-title--unimarc">
        Beneficios del Mes 
      </div>

      <div class="exclusive-discounts__grid">
        @for (discount of discounts.unimarc; track discount.id; let i = $index) {
          <div class="exclusive-discounts__card"
               [id]="'unimarc-' + discount.id"
               (click)="onPromotionClick(discount, 'unimarc', i)">
            <img [src]="discount.img"
                 [alt]="discount.titulo"
                 class="exclusive-discounts__image"
                 (error)="onImageError($event, 'unimarc', $index)" />
          </div>
        }
      </div>
    </div>

    <!-- Alvi Section 
    <div class="exclusive-discounts__section">
      <div class="exclusive-discounts__section-title exclusive-discounts__section-title--alvi">
        Exclusivo en Alvi
      </div>

      <div class="exclusive-discounts__grid">
        @for (discount of discounts.alvi; track discount.id; let i = $index) {
          <div class="exclusive-discounts__card"
               [id]="'alvi-' + discount.id"
               (click)="onPromotionClick(discount, 'alvi', i)">
            <img [src]="discount.img"
                 [alt]="discount.titulo"
                 class="exclusive-discounts__image"
                 (error)="onImageError($event, 'alvi', $index)" />
          </div>
        }
      </div>
    </div>

    <!-- Mayorista 10 Section
    <div class="exclusive-discounts__section">
      <div class="exclusive-discounts__section-title exclusive-discounts__section-title--mayorista10">
        Exclusivo en Super 10
      </div>

      <div class="exclusive-discounts__grid">
        @for (discount of discounts.mayorista; track discount.id; let i = $index) {
          <div class="exclusive-discounts__card"
               [id]="'mayorista-' + discount.id"
               (click)="onPromotionClick(discount, 'mayorista', i)">
            <img [src]="discount.img"
                 [alt]="discount.titulo"
                 class="exclusive-discounts__image"
                 (error)="onImageError($event, 'mayorista10', $index)" />
          </div>
        }
      </div>
    </div>-->
  </div>
</div>
